import { render, staticRenderFns } from "./PharmacyInfo.vue?vue&type=template&id=2070b019&scoped=true&"
import script from "./PharmacyInfo.vue?vue&type=script&lang=js&"
export * from "./PharmacyInfo.vue?vue&type=script&lang=js&"
import style0 from "./PharmacyInfo.vue?vue&type=style&index=0&id=2070b019&prod&scoped=true&lang=css&"
import style1 from "./PharmacyInfo.vue?vue&type=style&index=1&id=2070b019&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2070b019",
  null
  
)

export default component.exports